import ChevronDownIcon from "../../atoms/images/ChevronDownIcon";
import Text from "../content/Text";
import { cn } from "../../../helpers/utils";
import { AccordionItem } from "../../atoms/accordion/AccordionItem";
import { AccordionTrigger } from "../../atoms/accordion/AccordionTrigger";
import { AccordionContent } from "../../atoms/accordion/AccordionContent";

const AccordionItemWithHeader = ({ value, title, children }) => {
  return (
    <AccordionItem value={value}>
      <AccordionTrigger>
        <Text
          variant="small"
          className='group-data-[state="open"]:text-vestelColor'
        >
          {title}
        </Text>
        <ChevronDownIcon
          size={9}
          className={cn(
            "transition-transform duration-200",
            'group-data-[state="open"]:rotate-180'
          )}
        />
      </AccordionTrigger>
      <AccordionContent>{children}</AccordionContent>
    </AccordionItem>
  );
};

export default AccordionItemWithHeader;
